"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaAutocompleteOption = _interopRequireDefault(require("./AaAutocompleteOption.component"));

var _AaDropdown = require("./AaDropdown.model");

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _AaIconTypes = _interopRequireDefault(require("../airasia-icon-component/AaIconTypes"));

var _uiUtils = require("@airasia/ui-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ITEM_HEIGHT = 100;

var AaDropdown = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AaDropdown, _React$Component);

  var _super = _createSuper(AaDropdown);

  function AaDropdown(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AaDropdown);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOptionPress", function (item, index) {
      _this.props.controls.onOptionPress(item, index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isIE", function () {
      if (_reactNativeWeb.Platform.OS === "web") {
        var ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/

        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
        return is_ie;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToSection", function (event) {
      if (event.keyCode === 40) {
        if (_this.state.itemIndex < _this.props.data[0].data.length - 1) {
          _this.setState({
            itemIndex: _this.state.itemIndex + 1
          });

          _this.sectionListRef.scrollToLocation({
            sectionIndex: 0,
            itemIndex: _this.state.itemIndex,
            viewPosition: 0.5
          });
        }
      }

      if (event.keyCode === 38) {
        if (_this.state.itemIndex !== 0) {
          _this.sectionListRef.scrollToLocation({
            sectionIndex: 0,
            itemIndex: _this.state.itemIndex,
            viewPosition: 0.5
          });

          _this.setState({
            itemIndex: _this.state.itemIndex - 1
          });
        }
      }

      if (event.keyCode === 13) {
        event.preventDefault();

        if (_this.state.itemIndex < _this.props.data[0].data.length && _this.state.itemIndex >= 0) {
          _this.onOptionPress(_this.props.data[0].data[_this.state.itemIndex], _this.state.itemIndex);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getItemLayout", function (data, index) {
      return {
        length: ITEM_HEIGHT,
        offset: ITEM_HEIGHT * index,
        index: index
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderHeader", function (title) {
      var _this$props$controls = _this.props.controls,
          isNewDesign = _this$props$controls.isNewDesign,
          value = _this$props$controls.value;

      var _this$props$data = (0, _slicedToArray2["default"])(_this.props.data, 1),
          data = _this$props$data[0];

      var canShowEmptyResult = isNewDesign && data.data.length === 0;

      if (canShowEmptyResult) {
        var containerStyles = [newDesingStyles.noResultContainer];
        var isMobileLayout = _this.props.controls.isMobileLayout;

        if (isMobileLayout) {
          containerStyles.push(newDesingStyles.columnContainer);
        }

        return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
          style: containerStyles
        }, /*#__PURE__*/React.createElement(_AaIcon["default"], {
          controls: {
            iconName: _AaIconTypes["default"].NO_RESULTS,
            iconStyle: newDesingStyles.iconStyle
          }
        }), /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
          style: styles.sectionHeader
        }, /*#__PURE__*/React.createElement(_reactNativeWeb.Text, {
          style: newDesingStyles.noResultLabel
        }, title), /*#__PURE__*/React.createElement(_reactNativeWeb.Text, {
          style: newDesingStyles.valueLabel
        }, value)));
      }

      return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: styles.sectionHeader
      }, /*#__PURE__*/React.createElement(_reactNativeWeb.Text, {
        style: styles.headingSection
      }, title));
    });
    _this.secondaryLabel = _this.props.controls.secondaryLabel || '';
    _this.legend = _this.props.controls.legend || false;
    _this.top = _this.props.controls.isMobileLayout ? styles.mobileDropdown : null;
    _this.state = {
      itemIndex: 0
    };
    return _this;
  }

  (0, _createClass2["default"])(AaDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_reactNativeWeb.Platform.OS === "web") {
        document.addEventListener("keydown", this.scrollToSection);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_reactNativeWeb.Platform.OS === "web") {
        document.removeEventListener("keydown", this.scrollToSection);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: [styles.dropdownStyles, this.top, !this.props.controls.isMobileLayout && styles.legendInWeb, this.props.controls.customListStyles, this.props.controls.fullscreenView && styles.topFix, this.props.controls.isMobileLayout && styles.topFixMobile]
      }, this.legend && /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: [this.legend.styles && this.legend.styles, styles.legend]
      }, legend.items.map(function (item) {
        return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
          style: styles.legendItem,
          key: item.name
        }, /*#__PURE__*/React.createElement(_AaIcon["default"], {
          controls: {
            iconName: item.iconName
          }
        }), /*#__PURE__*/React.createElement(_reactNativeWeb.Text, {
          style: [styles.legendText, item.itemStyle && item.itemStyle]
        }, item.name));
      })), !this.props.controls.isListLoading ? /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: [styles.dropdownDefaultStyles, this.isIE() && this.props.data[0] && this.props.data[0].data && this.props.data[0].data.length > 0 && styles.dropdownFocus]
      }, /*#__PURE__*/React.createElement(_reactNativeWeb.SectionList, {
        onScrollToIndexFailed: function onScrollToIndexFailed() {},
        ref: function ref(_ref3) {
          return _this2.sectionListRef = _ref3;
        } // getItemLayout={this.getItemLayout}
        ,
        keyboardShouldPersistTaps: "handled",
        style: [styles.sectionListDefaultStyle, this.isIE() && this.props.data[0] && this.props.data[0].data && this.props.data[0].data.length > 0 && styles.dropdownFocus],
        sections: this.props.data,
        keyExtractor: function keyExtractor(item, index) {
          return index;
        },
        renderSectionHeader: function renderSectionHeader(_ref) {
          var title = _ref.section.title;
          return _this2.props.controls.displaySectionHeader ? _this2.renderHeader(title) : null;
        },
        renderItem: function renderItem(_ref2) {
          var item = _ref2.item,
              index = _ref2.index;
          return /*#__PURE__*/React.createElement(_AaAutocompleteOption["default"], {
            keyEle: index,
            controls: _objectSpread({
              index: index,
              isNewDesign: _this2.props.controls.isNewDesign,
              selectedIndex: _this2.state.itemIndex === index,
              onOptionPress: _this2.onOptionPress,
              item: item,
              secondaryLabel: _this2.secondaryLabel
            }, _this2.props.controls)
          });
        }
      })) : /*#__PURE__*/React.createElement(_reactNativeWeb.ActivityIndicator, {
        size: "large",
        color: "red",
        style: styles.defaultActivityIndicatorStyle
      }));
    }
  }]);
  return AaDropdown;
}(React.Component);

var styles = _StyleSheet["default"].create({
  topFix: {
    web: {
      top: '82',
      borderTopWidth: 'none',
      borderBottomColor: 'black',
      boxShadow: 'none',
      borderRadius: 'none'
    }
  },
  dropdownDefaultStyles: {
    flex: 1,
    backgroundColor: '#fff',
    paddingRight: 0,
    height: '100%'
  },
  sectionListDefaultStyle: {
    android: {
      //150 is height of action bar + search input field + padding
      height: Math.round(_reactNativeWeb.Dimensions.get('window').height) - 150
    },
    ios: {
      //150 is height of action bar + search input field + padding
      height: Math.round(_reactNativeWeb.Dimensions.get('window').height) - 150
    },
    web: {
      maxHeight: 350
    }
  },
  dropdownFocus: {
    web: {
      minHeight: 200
    }
  },
  sectionHeader: {
    web: {
      marginBottom: 12,
      paddingLeft: 16,
      marginTop: 8
    },
    android: {
      //  marginTop: 25,
      paddingHorizontal: 16,
      marginTop: 16,
      marginBottom: 8
    },
    ios: {
      //  marginTop: 25,
      paddingHorizontal: 16,
      marginTop: 16,
      marginBottom: 8
    }
  },
  iconStyle: {
    width: 24,
    height: 24,
    lineHeight: 24
  },
  legend: {
    flexDirection: 'row',
    backgroundColor: "#fff",
    padding: 15,
    web: {
      backgroundColor: 'white',
      borderTopColor: '#ccc',
      borderTopWidth: 1
    }
  },
  legendItem: {
    flexDirection: 'row',
    width: '50%'
  },
  legendText: {
    color: '#75767A',
    fontSize: 12
  },
  dropdownStyles: {
    width: '100%',
    backgroundColor: '#fff',
    position: 'absolute',
    zIndex: 100,
    top: 56,
    web: {
      cursor: 'pointer'
    }
  },
  mobileDropdown: {
    top: 80
  },
  legendInWeb: {
    web: {
      flexDirection: 'column-reverse',
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      shadowColor: '#000',
      shadowOffset: {
        width: 0.5,
        height: 1
      },
      shadowOpacity: 0.8,
      shadowRadius: 2,
      elevation: 1,
      borderColor: '#f2f2f2',
      borderTopWidth: 'none'
    }
  },
  defaultActivityIndicatorStyle: {
    marginTop: 10,
    web: {
      paddingVertical: '25',
      backgroundColor: 'white',
      marginTop: 0
    }
  },
  topFixMobile: {
    web: {
      top: 85,
      borderTopWidth: 1,
      borderTopColor: 'rgba(0,0,0,0.1)',
      minHeight: 350
    }
  },
  headingSection: {
    color: '#212124',
    fontSize: 16,
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    web: {
      fontWeight: '500',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var newDesingStyles = _StyleSheet["default"].create({
  noResultContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 16
  },
  columnContainer: {
    flexDirection: 'column'
  },
  iconStyle: {
    width: 48,
    height: 48,
    web: {
      flexGrown: 0
    }
  },
  noResultLabel: {
    fontSize: 14,
    lineHeight: 22
  },
  valueLabel: {
    fontSize: 12,
    lineHeight: 18,
    color: '#75767A'
  }
});

var _default = AaDropdown;
exports["default"] = _default;